import { CallEmsApi, GetGenericListResponse, iEmsApiResponseBody } from "./TenantAPI";

export interface GetDepartmentResponse {
    items: Departments[];
}

export interface Departments {
    id: number;
    name: string;
}

export async function GetDepartments(tenantToken: string): Promise<iEmsApiResponseBody<GetGenericListResponse>> {
    const results = await CallEmsApi<GetGenericListResponse>(tenantToken, "GET", `Departments`);
    if (results.isOk && results.data) {
        results.data.items.sort((a, b) => a.name.localeCompare(b.name));
    }
    return results;
}
